export var FontItemID;
(function (FontItemID) {
    FontItemID["BOLD"] = "bold";
    FontItemID["ITALIC"] = "italic";
    FontItemID["UNDERLINE"] = "underline";
    FontItemID["STRIKE_THROUGH"] = "strike-through";
    FontItemID["WRAP"] = "wrap";
})(FontItemID || (FontItemID = {}));
//# sourceMappingURL=font-formatter-id.js.map